/**
 * Transporte HTTP inyectable para todo el módulo DynamicEntities.
 *
 * El kit no sabe nada de autenticación: la app anfitriona inyecta su propio
 * `fetch` (ya con `Authorization`, `X-Company-Id`, `Accept-Language`, tracing o
 * reintentos) a través de `DynamicEntitiesProvider`. Si no se inyecta ninguno se
 * usa el `fetch` global y el comportamiento es idéntico al de siempre.
 */
export type DynamicEntitiesFetcher = typeof fetch;

/**
 * Normaliza el transporte para poder guardarlo como propiedad de una clase o de
 * un objeto.
 *
 * Envolverlo no es cosmético: `this.http(url)` invocaría el `fetch` global con
 * la instancia como receptor y los navegadores lanzan `Illegal invocation`
 * cuando `fetch` pierde su `window`. La arrow function lo llama siempre como
 * función suelta, que es lo que tanto el `fetch` nativo como cualquier fetcher
 * del anfitrión esperan.
 */
export const resolveFetcher = (fetcher?: DynamicEntitiesFetcher): DynamicEntitiesFetcher =>
    fetcher
        ? (input, init) => fetcher(input, init)
        : (input, init) => fetch(input, init);
